<template>
	<div id="cleaning-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4">CLEANING</h4>
							<a id="add_cleaning_btn" class="btn btn-success btn-sm" href="#" role="button" data-bs-toggle="modal" data-bs-target="#addCleaningModal" v-if="['110', '111'].indexOf(all_permissions) >= 0">ADD</a>
						</div>
					</div>
				</div>
				<DataTableComponent :dataprops="dataprops" @view-object="viewCleaning"  @upload-object="uploadImages" @duplicate-object="duplicateObject" @print-object="printCleaning" @edit-object="prepareEditCleaning" @toggle-object-status="toggleCleaning" v-if="mode != 'mobileapp'"></DataTableComponent>
			</div>
		</div>
		<div class="modal fade" ref="addEditModal" id="addCleaningModal" tabindex="-1" aria-labelledby="addCleaningModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addCleaningModalLabel"><span v-if="cleaningForAdd.id == 0">Add</span><span v-else>Edit</span> Cleaning Record</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-0 mb-sm-4">
							<div class="col-md-4 d-flex justify-content-md-end align-items-center">
								<label for="add_cleaning_tank_no" class="form-label text-uppercase fw-bold m-0 me-3">Tank No <span class="mandatory">*</span></label
								><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
							</div>
							<div class="col-12 col-sm-3 mb-2 mb-sm-0">
								<div class="input-group">
									<MaskInput v-model="cleaningForAdd.tank_no" mask="AAAA-######-#" class="form-control" :readonly="tankNoVerified" textmode="uppercase"/>
									<span class="input-group-text" :class="tankNoVerified ? 'bg-success' : 'bg-danger'">
										<i class="ph ph-check text-white" v-if="tankNoVerified"></i>
										<i class="ph ph-x text-white" v-if="!tankNoVerified"></i>
									</span>
								</div>
								<template v-for="error of v$.cleaningForAdd.tank_no.$errors" :key="error.$uid">
									<div class="mandatory mb-1">{{ error.$message }}</div>
								</template>
							</div>
							<div class="col-12 py-sm-2 mb-2 mb-sm-0" v-if="cleaningForAdd.id == 0 && tankNoVerified">
								<label for="">Tank last used: <span v-if="lastThree && lastThree.length > 0">On {{  lastThree.join(", ") }}</span><span v-else>Never</span></label>
							</div>
						</div>
						<template v-if="tankNoVerified">
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center" v-if="tankNoVerified">
									<label for="add_cleaning_ref_no" class="form-label text-uppercase fw-bold mb-0 me-3">Ref No</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0" v-if="tankNoVerified">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.ref_no" id="add_cleaning_ref_no" placeholder="AUTOGENERATED" disabled/>
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_company_id" class="form-label text-uppercase fw-bold me-3">Company <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.company_id" id="add_company_id">
											<optgroup v-if="allCompanyIdList" label="Choose Company">
												<template v-for="companyId in allCompanyIdList" :key="companyId.id">
													<option :value="companyId.id">{{ companyId.name }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.cleaningForAdd.company_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_tank_type_id" class="form-label text-uppercase fw-bold me-3">Tank Type <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.tank_type_id" id="add_tank_type_id">
											<optgroup v-if="allTankIdList" label="Choose Tank Type">
												<template v-for="tankId in allTankIdList" :key="tankId.id">
													<option :value="tankId.id">{{ tankId.type }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.cleaningForAdd.tank_type_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_tcode_id" class="form-label text-uppercase fw-bold me-3">TCode <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.tcode_id" id="add_tcode_id">
											<optgroup v-if="allTcodeIdList" label="Choose TCode">
												<template v-for="tcodeId in allTcodeIdList" :key="tcodeId.id">
													<option :value="tcodeId.id">{{ tcodeId.name }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.cleaningForAdd.tcode_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-6 mb-2 mb-sm-0 d-md-flex d-none justify-content-end align-items-center">
									<!-- <label for="add_cleaning_customer_id" class="form-label text-uppercase fw-bold me-3">Cleaning Co. M/s <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.customer_id" id="add_cleaning_customer_id">
											<optgroup v-if="allInspectionLocnList" label="Choose Cleaning Co. M/s">
												<template v-for="inspectionLocn in allInspectionLocnList" :key="inspectionLocn.id">
													<option :value="inspectionLocn.id">{{ inspectionLocn.name }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.cleaningForAdd.customer_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template> -->
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_csc" class="form-label text-uppercase fw-bold me-3">Csc</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.csc" id="add_cleaning_csc" placeholder="Enter Csc" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_mfgt_date" class="form-label text-uppercase fw-bold me-3">Mfgt. Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.mfgt_date" id="add_cleaning_mfgt_date" placeholder="Enter Mfgt Date" />
										<!-- <MonthYearPicker v-model="cleaningForAdd.mfgt_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select"/> -->
										<!-- {{  cleaningForAdd.mfgt_date }} -->
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_last_inspection_date" class="form-label text-uppercase fw-bold me-3">Last Inspection Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.last_inspection_date" id="add_cleaning_last_inspection_date" placeholder="Enter Last Inspection Date" />
										<!-- <MonthYearPicker  v-model="cleaningForAdd.last_inspection_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select"/> -->
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_next_date" class="form-label text-uppercase fw-bold me-3">Next Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.next_date" id="add_cleaning_next_date" placeholder="Enter Next Date" />
										<!-- <MonthYearPicker  v-model="cleaningForAdd.next_date" :min="new Date()" :max="new Date(new Date().getTime()+(2*365*24*60*60*1000))" returnmode="String" class="form-select"/> -->
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_mgw" class="form-label text-uppercase fw-bold me-3">Mgw</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="number" v-empty-zero class="form-control" v-model="cleaningForAdd.mgw" id="add_cleaning_mgw" placeholder="Enter Mgw" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_tare_wt" class="form-label text-uppercase fw-bold me-3">Tare Wt</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="number" v-empty-zero class="form-control" v-model="cleaningForAdd.tare_wt" id="add_cleaning_tare_wt" placeholder="Enter Tare Wt" />
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_capacity" class="form-label text-uppercase fw-bold me-3">Capacity</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="number" v-empty-zero class="form-control" v-model="cleaningForAdd.capacity" id="add_cleaning_capacity" placeholder="Enter Capacity" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-md-end align-items-center">
									<label for="add_cleaning_inspection_locn" class="form-label text-uppercase fw-bold me-3">Inspection Location <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<multiselect v-model="cleaningForAdd.inspection_locn" :options="allInspectionLocnList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
									<template v-for="error of v$.cleaningForAdd.inspection_locn.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
								<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_cleaning_location_id" class="form-label text-uppercase fw-bold me-3">Cleaning Location <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.cleaning_location_id" id="add_cleaning_location_id">
											<optgroup v-if="allCleaningLocationIdList" label="Choose Cleaning Location">
												<template v-for="cleaningLocationId in allCleaningLocationIdList" :key="cleaningLocationId.id">
													<option :value="cleaningLocationId.id">{{ cleaningLocationId.name }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.cleaningForAdd.cleaning_location_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div> -->
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_customer_id" class="form-label text-uppercase fw-bold me-3">For M/s.<span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<multiselect v-model="cleaningForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
									<template v-for="error of v$.cleaningForAdd.customer_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_inspection_date" class="form-label text-uppercase fw-bold me-3">Inspection Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<MaskInput v-model="cleaningForAdd.inspection_date" mask="##-##-####" class="form-control" textmode="uppercase" placeholder="DD-MM-YYYY"/>
										<!-- <input type="text" class="form-control" v-model="cleaningForAdd.inspection_date" id="add_cleaning_inspection_date" placeholder="Enter Inspection Date"/> -->
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_ref" class="form-label text-uppercase fw-bold me-3">Ref</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.ref" id="add_cleaning_ref" placeholder="Enter Ref" />
									</div>
								</div> -->
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_last_cargo_carried" class="form-label text-uppercase fw-bold me-3 text-end">Last Cargo Carried</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<input type="text" class="form-control" v-model="cleaningForAdd.last_cargo_carried" id="add_cleaning_last_cargo_carried" placeholder="Enter Last Cargo Carried" />
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_surveyor_id" class="form-label text-uppercase fw-bold me-3">Surveyor <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0">
									<div>
										<multiselect v-model="cleaningForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
									<template v-for="error of v$.cleaningForAdd.surveyor_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 p-2 bg-info text-center">
									<h5 class="m-0">EXTERIOR</h5>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_frame_tank" class="form-label me-3 mb-0">Frame, Tank and walkways free of contamination and cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.frame_tank" id="add_frame_tank">
											<optgroup v-if="allFrameTankList" label="Choose">
												<template v-for="frameTank in allFrameTankList" :key="frameTank.id">
													<option :value="frameTank.id">{{ frameTank.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_manlid_valves" class="form-label me-3 mb-0">Manlid and Valve compartments free of contamination and cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.manlid_valves" id="add_manlid_valves">
											<optgroup v-if="allManlidValvesList" label="Choose">
												<template v-for="manlidValves in allManlidValvesList" :key="manlidValves.id">
													<option :value="manlidValves.id">{{ manlidValves.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_serial_nos" class="form-label me-3 mb-0">Serial numbers and statutory</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.serial_nos" id="add_serial_nos">
											<optgroup v-if="allSerialNosList" label="Choose Serial numbers and statutory">
												<template v-for="serialNos in allSerialNosList" :key="serialNos.id">
													<option :value="serialNos.id">{{ serialNos.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_labels_removed" class="form-label me-3 mb-0">Cargo Labels removed</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.labels_removed" id="add_labels_removed">
											<optgroup v-if="allLabelsRemovedList" label="Choose Cargo Labels removed">
												<template v-for="labelsRemoved in allLabelsRemovedList" :key="labelsRemoved.id">
													<option :value="labelsRemoved.id">{{ labelsRemoved.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 p-2 bg-info text-center">
									<h5 class="m-0">INTERIOR</h5>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_entry" class="form-label me-3 mb-0">Entry made into tank by surveyor</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.entry" id="add_entry">
											<optgroup v-if="allEntryList" label="Choose Entry made into tank by surveyor">
												<template v-for="entry in allEntryList" :key="entry.id">
													<option :value="entry.id">{{ entry.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_odour_free" class="form-label me-3 mb-0">Free from odour</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.odour_free" id="add_odour_free">
											<optgroup v-if="allOdourFreeList" label="Choose Free from odour">
												<template v-for="odourFree in allOdourFreeList" :key="odourFree.id">
													<option :value="odourFree.id">{{ odourFree.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_clean_free" class="form-label me-3 mb-0">Clean and free from last cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.clean_free" id="add_clean_free">
											<optgroup v-if="allCleanFreeList" label="Choose Clean and free from last cargo">
												<template v-for="cleanFree in allCleanFreeList" :key="cleanFree.id">
													<option :value="cleanFree.id">{{ cleanFree.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_corrosion_free" class="form-label me-3 mb-0">Free from corrosion</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.corrosion_free" id="add_corrosion_free">
											<optgroup v-if="allCorrosionFreeList" label="Choose Free from corrosion">
												<template v-for="corrosionFree in allCorrosionFreeList" :key="corrosionFree.id">
													<option :value="corrosionFree.id">{{ corrosionFree.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_dry" class="form-label me-3 mb-0">Dry</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.dry" id="add_dry">
											<optgroup v-if="allDryList" label="Choose Dry">
												<template v-for="dry in allDryList" :key="dry.id">
													<option :value="dry.id">{{ dry.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 p-2 bg-info text-center">
									<h5 class="m-0 text-uppercase">VALVES/FITTINGS free from previous cargo</h5>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_valves" class="form-label me-3 mb-0">Valves</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.valves" id="add_valves">
											<optgroup v-if="allValvesList" label="Choose Valves">
												<template v-for="valves in allValvesList" :key="valves.id">
													<option :value="valves.id">{{ valves.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_manlid_seal" class="form-label me-3 mb-0">Manlid Seal</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.manlid_seal" id="add_manlid_seal">
											<optgroup v-if="allManlidSealList" label="Choose Manlid Seal">
												<template v-for="manlidSeal in allManlidSealList" :key="manlidSeal.id">
													<option :value="manlidSeal.id">{{ manlidSeal.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_gas_free" class="form-label me-3 mb-0">Gas free entry permit issue</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.gas_free" id="add_gas_free">
											<optgroup v-if="allGasFreeList" label="Choose Gas free entry permit issue">
												<template v-for="gasFree in allGasFreeList" :key="gasFree.id">
													<option :value="gasFree.id">{{ gasFree.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-8 d-flex justify-content-end align-items-center">
									<label for="add_cleaning_siphon" class="form-label me-3 mb-0">Siphon Tube</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0">
									<div>
										<select class="form-select" v-model="cleaningForAdd.siphon" id="add_siphon">
											<optgroup v-if="allSiphonList" label="Choose Siphon Tube">
												<template v-for="siphon in allSiphonList" :key="siphon.id">
													<option :value="siphon.id">{{ siphon.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-6 mb-2 mb-sm-0">
									<label for="add_cleaning_remarks" class="form-label text-uppercase fw-bold me-3">Remarks</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
									<div>
										<textarea class="form-control" v-model="cleaningForAdd.remarks" id="add_cleaning_remarks" placeholder="Enter Remarks" rows="3"></textarea>
									</div>
								</div>
								<div class="col-12 col-sm-6 mb-2 mb-sm-0">
									<label for="add_cleaning_interior" class="form-label text-uppercase fw-bold me-3">Interior</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
									<div>
										<textarea class="form-control" v-model="cleaningForAdd.interior" id="add_cleaning_interior" placeholder="Enter Interior" rows="3"></textarea>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-6 mb-2 mb-sm-0">
									<label for="add_cleaning_exterior" class="form-label text-uppercase fw-bold me-3">Exterior/Comment</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
									<div>
										<textarea class="form-control" v-model="cleaningForAdd.exterior" id="add_cleaning_exterior" placeholder="Enter Exterior/Comment" rows="3"></textarea>
									</div>
								</div>
								<div class="col-12 col-sm-6 mb-2 mb-sm-0">
									<label for="add_cleaning_sealno" class="form-label text-uppercase fw-bold me-3">Seal No</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
									<div>
										<textarea class="form-control" v-model="cleaningForAdd.sealno" id="add_cleaning_sealno" placeholder="Enter Seal No" rows="3"></textarea>
									</div>
								</div>
							</div>
						</template>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal" @click="cancelAddEdit()">CLOSE</button>
						<button type="button" class="btn btn-dark btn-sm" v-if="tankNoVerified" @click="saveCleaning()">SAVE CHANGES</button>
						<button type="button" class="btn btn-dark btn-sm" v-else @click="verifyTankNumber()">VERIFY TANK NUMBER</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" ref="readModal" id="readCleaningModal" tabindex="-1" aria-labelledby="readCleaningModalLabel" aria-hidden="true" v-if="readCleaning">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="readCleaningModalLabel">View Cleaning Record</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Company</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.company?.name">{{ readCleaning.company?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Ref No</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.ref_no">{{ readCleaning.ref_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Tank Type</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.tank?.type">{{ readCleaning.tank?.type }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Tank No</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.tank_no">{{ readCleaning.tank_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Tcode</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.tcode?.name">{{ readCleaning.tcode?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-6 mb-2 mb-sm-0 d-md-flex d-none justify-content-end">
								<!-- <label class="form-label text-uppercase fw-bold m-0">Cleaning CO. M/s.</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.customer?.name">{{ readCleaning.customer?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div> -->
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Csc</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.csc">{{ readCleaning.csc }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Mfgt Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.mfgt_date">{{ readCleaning.mfgt_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0 text-end">Last Inspection Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.last_inspection_date">{{ readCleaning.last_inspection_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Mgw</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.mgw">{{ readCleaning.mgw }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Next Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.next_date">{{ readCleaning.next_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Capacity</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.capacity">{{ readCleaning.capacity }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Tare Wt</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.tare_wt">{{ readCleaning.tare_wt }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0 text-end">Inspection Location</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.inspectionlocation?.name">{{ readCleaning.inspectionlocation?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Inspection Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.inspection_date">{{ readCleaning.inspection_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">For M/s.</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.customer?.name">{{ readCleaning.customer?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Cleaning Location</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.cleaninglocation?.name">{{ readCleaning.cleaninglocation?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div> -->
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-6 mb-2 mb-sm-0 d-md-flex d-none justify-content-end">
								<!-- <label class="form-label text-uppercase fw-bold m-0">Ref</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.ref">{{ readCleaning.ref }}</span
									><span v-else><i>Not specified</i></span>
								</div> -->
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0 test-end">Last Cargo Carried</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.last_cargo_carried">{{ readCleaning.last_cargo_carried }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Surveyor</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.surveyor?.name">{{ readCleaning.surveyor?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Status</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span class="badge rounded-pill bg-success" v-if="readCleaning.status == 1">ACTIVE</span>
									<span class="badge rounded-pill bg-danger" v-if="readCleaning.status == 0">INACTIVE</span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Created By</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.creator?.name">{{ readCleaning.creator?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-12 p-2 bg-info text-center">
								<h5 class="m-0">EXTERIOR</h5>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Frame, Tank and walkways free of contamination and cargo</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.frame_tank == '1'">Yes</span>
									<span v-if="readCleaning.frame_tank == '-1'">No</span>
									<span v-if="readCleaning.frame_tank == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Manlid and Valve compartments free of contamination and cargo</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.manlid_valves == '1'">Yes</span>
									<span v-if="readCleaning.manlid_valves == '-1'">No</span>
									<span v-if="readCleaning.manlid_valves == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Serial numbers and statutory</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.serial_nos == '1'">Yes</span>
									<span v-if="readCleaning.serial_nos == '-1'">No</span>
									<span v-if="readCleaning.serial_nos == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Cargo Labels removed</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.labels_removed == '1'">Yes</span>
									<span v-if="readCleaning.labels_removed == '-1'">No</span>
									<span v-if="readCleaning.labels_removed == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-12 p-2 bg-info text-center">
								<h5 class="m-0">INTERIOR</h5>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Entry made into tank by surveyor</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.entry == '1'">Yes</span>
									<span v-if="readCleaning.entry == '-1'">No</span>
									<span v-if="readCleaning.entry == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Free from odour</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.odour_free == '1'">Yes</span>
									<span v-if="readCleaning.odour_free == '-1'">No</span>
									<span v-if="readCleaning.odour_free == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Clean and free from last cargo</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.clean_free == '1'">Yes</span>
									<span v-if="readCleaning.clean_free == '-1'">No</span>
									<span v-if="readCleaning.clean_free == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Free from corrosion</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.corrosion_free == '1'">Yes</span>
									<span v-if="readCleaning.corrosion_free == '-1'">No</span>
									<span v-if="readCleaning.corrosion_free == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Dry</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.dry == '1'">Yes</span>
									<span v-if="readCleaning.dry == '-1'">No</span>
									<span v-if="readCleaning.dry == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-12 p-2 bg-info text-center">
								<h5 class="m-0">VALVES/FITTINGS free from previous cargo</h5>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Valves</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.valves == '1'">Yes</span>
									<span v-if="readCleaning.valves == '-1'">No</span>
									<span v-if="readCleaning.valves == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Manlid Seal</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.manlid_seal == '1'">Yes</span>
									<span v-if="readCleaning.manlid_seal == '-1'">No</span>
									<span v-if="readCleaning.manlid_seal == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0 text-end">Gas free entry permit issue</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.gas_free == '1'">Yes</span>
									<span v-if="readCleaning.gas_free == '-1'">No</span>
									<span v-if="readCleaning.gas_free == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Siphon Tube</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.siphon == '1'">Yes</span>
									<span v-if="readCleaning.siphon == '-1'">No</span>
									<span v-if="readCleaning.siphon == '0'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Remarks</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.remarks">{{ readCleaning.remarks }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Interior</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.interior">{{ readCleaning.interior }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Exterior/Comment</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.exterior">{{ readCleaning.exterior }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-8 d-flex justify-content-end">
								<label class="form-label text-uppercase fw-bold m-0">Seal No</label>
							</div>
							<div class="col-4 col-sm-2 mb-2 mb-sm-0">
								<div>
									<span v-if="readCleaning.sealno">{{ readCleaning.sealno }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal">CLOSE</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Upload Images -->
		<UploadImages :dataprops="uploadDataprops" @refresh-object="refreshObject"></UploadImages>
		<!-- Upload Images -->
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			company_id: null,
			ref_no: "",
			tank_type_id: null,
			tank_no: "",
			tcode_id: null,
			customer_id: null,
			csc: "",
			mfgt_date: null,
			last_inspection_date: "",
			mgw: 0,
			next_date: "",
			capacity: 0,
			tare_wt: 0,
			inspection_locn: null,
			inspection_date: "",
			// client_id: null,
			cleaning_location_id: 0,
			ref: "",
			last_cargo_carried: "",
			surveyor_id: null,
			frame_tank: 1,
			manlid_valves: 1,
			serial_nos: 1,
			labels_removed: 1,
			entry: 1,
			odour_free: 1,
			clean_free: 1,
			corrosion_free: 1,
			dry: 1,
			valves: 1,
			manlid_seal: 1,
			gas_free: 1,
			siphon: 1,
			remarks: "",
			interior: "",
			exterior: "",
			sealno: "",
			action: ""
		};
	}
	function initialStateValidations() {
		return {
			company_id: {required},
			ref_no: {minLengthValue: minLength(1)},
			tank_type_id: {required},
			tank_no: {required, minLengthValue: minLength(1)},
			tcode_id: {required},
			customer_id: {required},
			csc: {minLengthValue: minLength(1)},
			mfgt_date: {},
			last_inspection_date: {},
			mgw: {numeric, minValue: minValue(0)},
			next_date: {},
			capacity: {numeric, minValue: minValue(0)},
			tare_wt: {numeric, minValue: minValue(0)},
			inspection_locn: {required},
			inspection_date: {},
			// client_id: {required},
			ref: {minLengthValue: minLength(1)},
			last_cargo_carried: {minLengthValue: minLength(1)},
			surveyor_id: {required},
			frame_tank: {required},
			manlid_valves: {required},
			serial_nos: {required},
			labels_removed: {required},
			entry: {required},
			odour_free: {required},
			clean_free: {required},
			corrosion_free: {required},
			dry: {required},
			valves: {required},
			manlid_seal: {required},
			gas_free: {required},
			siphon: {required},
			remarks: {minLengthValue: minLength(1)},
			interior: {minLengthValue: minLength(1)},
			exterior: {minLengthValue: minLength(1)},
			sealno: {minLengthValue: minLength(1)}
		};
	}
	export default {
		name: "Cleaningmaster",
		props: ["current_user_id", "all_permissions", "mode", "param1","id"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				dataprops: {
					id: "cleaning-list",
					class: "a",
					base_url: this.docRoot+"/api/cleaning/",
					columns: [
						{title: "Company", property: "company.name", alt_value: "Not Specified"},
						{title: "Ref No", property: "ref_no"},
						// {title: "Tank Type", property: "tank.name", alt_value: "Not Specified"},
						{title: "Tank No", property: "tank_no", sortable: true},
						// {title: "TCode", property: "tcode.name", alt_value: "Not Specified"},
						{ title: "Customer", property: "customer.name", alt_value: "Not Specified" },
						{ title: "Survey Date", property: "inspection_date", alt_value: "Not Specified" },
						{title: "Remarks", property: "remarks"},
						{title: "NED", property: "next_date"},
						{title: "Created By", property: "creator.name", alt_value: "Not Specified"}
					],
					data_to_send: {current_user_id: this.current_user_id},
					reload: false,
					search: "simple"
				},
				uploadDataprops: {
					relatedObject: null,
					name: "Cleaning",
				},
				addEditModal: null,
				readModal: null,
				currentUser: siteUserObject,
				cleaningForAdd: initialState(),
				readCleaning: {},
				allCompanyIdList: [],
				allTankIdList: [],
				allTcodeIdList: [],
				allCustomerIdList: [],
				allInspectionLocnList: [],
				allClientIdList: [],
				allCleaningLocationIdList: [],
				allSurveyorIdList: [],
				allFrameTankList: [],
				allManlidValvesList: [],
				allSerialNosList: [],
				allLabelsRemovedList: [],
				allEntryList: [],
				allOdourFreeList: [],
				allCleanFreeList: [],
				allCorrosionFreeList: [],
				allDryList: [],
				allValvesList: [],
				allManlidSealList: [],
				allGasFreeList: [],
				allSiphonList: [],
				tankNoVerified: false,
				lastThree: []
			};
		},
		validations() {
			return {
				cleaningForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.cleaningForAdd = initialState();
				this.tankNoVerified = false;
				this.v$.$reset();
			},
			verifyTankNumber() {
				var that = this;
				this.showLoading("Verifying ...");
				axios
					.post(this.docRoot + "/cleaning/verify-tank-number", { tankNo: this.cleaningForAdd.tank_no })
					.then(async function (response) {
						that.closeSwal();
						// console.log(response);
						var status = response.data.status;
						if (status == 1){
							that.tankNoVerified = true;
							if (response.data.hasOwnProperty("lastthree") && response.data.lastthree.length > 0) {
								let arrLastThree = response.data.lastthree;
								that.lastThree = arrLastThree.filter((item, index) => arrLastThree.indexOf(item) === index);
							}
						}
						else {
							that.tankNoVerified = false;
							that.showErrors(response.data.message, "error", "bottom", 3000);
						}
					});
			},
			duplicateObject(cleaning) {
				let that = this;
				this.showConfirm("Are you sure you want to create a duplicate of this record?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						if (cleaning.surveyor_id) {
							if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
								let _allRelationList = this.allSurveyorIdList;
								let relationId = parseInt(cleaning.surveyor_id);
								cleaning.surveyor_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						if (cleaning.customer_id) {
							if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
								let _allRelationList = this.allCustomerIdList;
								let relationId = parseInt(cleaning.customer_id);
								cleaning.customer_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						if (cleaning.inspection_locn) {
							if (Array.isArray(this.allInspectionLocnList) && this.allInspectionLocnList.length > 0) {
								let _allRelationList = this.allInspectionLocnList;
								let relationId = parseInt(cleaning.inspection_locn);
								cleaning.inspection_locn = _allRelationList.find(item => item.id === relationId);
							}
						}
						this.cleaningForAdd = Object.assign({}, cleaning);
						this.cleaningForAdd.id = 0;
						this.cleaningForAdd.ref_no = null;
						this.tankNoVerified = false;
						this.addEditModal.show();
					}
				});
			},
			async saveCleaning(event) {
				var that = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				// Validate the inspection date
				if ( this.cleaningForAdd.inspection_date.length < 10) {
					this.showToast("Inspection date is required", "error", "bottom", 2000);
					return;
				}
				else {
					// validate date using regex
					var dateRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
					if (!dateRegex.test(this.cleaningForAdd.inspection_date)) {
						this.showToast("Invalid inspection date format", "error", "bottom", 2000);
						return;
					}
				}
				if ( that.cleaningForAdd.surveyor_id != 'null' && typeof that.cleaningForAdd.surveyor_id === 'object' && that.cleaningForAdd.surveyor_id.id) {
					that.cleaningForAdd.surveyor_id = that.cleaningForAdd.surveyor_id.id;
				}
				if ( that.cleaningForAdd.customer_id != 'null' && typeof that.cleaningForAdd.customer_id === 'object' && that.cleaningForAdd.customer_id.id) {
					that.cleaningForAdd.customer_id = that.cleaningForAdd.customer_id.id;
				}
				if ( that.cleaningForAdd.inspection_locn != 'null' && typeof that.cleaningForAdd.inspection_locn === 'object' && that.cleaningForAdd.inspection_locn.id) {
					that.cleaningForAdd.inspection_locn = that.cleaningForAdd.inspection_locn.id;
				}
				if (!this.cleaningForAdd.action || this.cleaningForAdd.action == "") this.cleaningForAdd.action = "details";
				this.cleaningForAdd.created_by = this.current_user_id;
				// $("#addCleaningModal").modal("hide");
				bootstrap.Modal.getInstance(document.getElementById('addCleaningModal')).hide();
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot+"/cleaning/save", {cleaning: this.cleaningForAdd})
					.then(async function (response) {
						that.closeSwal();
						var status = response.data.status;
						if (status > 0) {
							// Ajax to submit
							that.showToast("Cleaning saved successfully", "success", "bottom", 3000);
							if(that.mode === "mobileapp") {
								window.location = that.docRoot+"/operation-successful";
							}
							setTimeout(() => {
								that.dataprops.reload = true;
							}, 1500);
							that.cleaningForAdd = initialState();
							that.tankNoVerified = false;
							that.v$.$reset();
						}
						else {
							that.showErrors("Cleaning could not be saved successfully", response.data.messages, "bottom", 3000);
						}
					})
					.catch(function (error) {
						console.log(error);
						that.closeSwal();
						that.showToast("Cleaning could not be saved successfully", "error", "bottom", 3000);
					});
			},
			prepareEditCleaning(cleaning) {
				var dateRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
				if (!dateRegex.test(cleaning.inspection_date)) {
					cleaning.inspection_date = "";
				}
				this.cleaningForAdd = Object.assign({}, cleaning);
				this.tankNoVerified = false;
				this.addEditModal.show();
				if (this.cleaningForAdd.surveyor_id) {
					if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
						let _allRelationList = this.allSurveyorIdList;
						let relationId = parseInt(this.cleaningForAdd.surveyor_id);
						this.cleaningForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.cleaningForAdd.customer_id) {
					if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
						let _allRelationList = this.allCustomerIdList;
						let relationId = parseInt(this.cleaningForAdd.customer_id);
						this.cleaningForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.cleaningForAdd.inspection_locn) {
					if (Array.isArray(this.allInspectionLocnList) && this.allInspectionLocnList.length > 0) {
						let _allRelationList = this.allInspectionLocnList;
						let relationId = parseInt(this.cleaningForAdd.inspection_locn);
						this.cleaningForAdd.inspection_locn = _allRelationList.find(item => item.id === relationId);
					}
				}
			},
			viewCleaning(cleaning) {
				this.readCleaning = cleaning;
				this.readModal.show();
			},
			toggleCleaning(cleaning, status) {
				var that = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "activate" : "deactivate") + ' the Cleaning record?',
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						that.cleaningForAdd = cleaning;
						that.cleaningForAdd.status = status;
						that.cleaningForAdd.action = "status";
						that.saveCleaning();
					}
				});
			},
			printCleaning(cleaning) {
				window.location = this.docRoot+'/cleaning/export-to-pdf/' + cleaning.id;
				this.showToast("Printing. Please wait ...", "success", "bottom", 3000);
			},
			async uploadImages(cleaning) {
				this.showLoading("Loading images ...");
				await this.refreshObject(cleaning, "Cleaning", 1);
				this.closeSwal();
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			this.addEditModal = new bootstrap.Modal(this.$refs.addEditModal, {backdrop: "static", keyboard: false});
			this.readModal = new bootstrap.Modal(this.$refs.readModal, {backdrop: "static", keyboard: false});
			if (this.mode && this.mode == "mobileapp") {
				if(this.param1 && this.param1 != null && this.param1 != undefined) {
					if (this.id !== undefined && !isNaN(this.id)) {
						var URL = this.docRoot + "/api/cleaning/get-record/" + this.id;
						var that = this;
						this.showLoading("Loading ...");
						axios.post(URL, {}).then(function (response) {
							let cleaningObj = Object.assign({}, response.data);
							if(that.param1 === "edit"){
								that.prepareEditCleaning(cleaningObj);
							}else{
								that.viewCleaning(cleaningObj);
							}
							that.closeSwal();	
						})
						.catch(function (error) {
							console.log(error);
						});
					}
				}else{
					this.addEditModal.show();
				}
				this.$refs.addEditModal.addEventListener('hidden.bs.modal', () => { window.location = this.docRoot + "/operation-canceled"; });
				this.$refs.readModal.addEventListener('hidden.bs.modal', () => { window.location = this.docRoot + "/operation-canceled"; });
			}
			let _allSurveyorIdList = await this.loadAllSurveyor(true);
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCustomerIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
			if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
				this.allInspectionLocnList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			this.allCompanyIdList = await this.loadAllCompany(true);
			this.allTankIdList = await this.loadAllTankType(true);
			this.allTcodeIdList = await this.loadAllTcode(true);
			this.allClientIdList = await this.loadAllCustomer(true);
			this.allCleaningLocationIdList = await this.loadAllCleaningLocation(true);
			this.allFrameTankList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allManlidValvesList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allSerialNosList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allLabelsRemovedList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allEntryList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allOdourFreeList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allCleanFreeList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allCorrosionFreeList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allDryList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allValvesList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allManlidSealList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allGasFreeList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
			this.allSiphonList = [
				{id: "1", title: "Yes"},
				{id: "-1", title: "No"},
				{id: "0", title: "NA"}
			];
		}
	};
</script>
